import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isElmServiceProvider: null,
};

const serviceProviderSlice = createSlice({
  name: "serviceProvider",
  initialState,
  reducers: {
    setServiceProvider: (state, action) => {
      console.log("action", action.payload)
      state.isElmServiceProvider = action.payload;
    },
    clearServiceProvider: (state) => {
      state.isElmServiceProvider = null;
    },
  },
});

export const { setServiceProvider, clearServiceProvider } = serviceProviderSlice.actions;
export default serviceProviderSlice.reducer;
